import { createAsyncThunk } from '@reduxjs/toolkit';
import actionTypes from './actionTypes';
import { Operator } from './models';
import axiosInstance from '../../utils/axios';
import { getAppDetails } from '../../utils/terminal';

export const loginOperator = createAsyncThunk(actionTypes.OPERATOR_LOGIN, async (authorizationCode: string): Promise<Operator> => {
  try {
    console.log('start logging Operator');
    const appDetails = await getAppDetails();
    const response = await axiosInstance.post<Operator>(`/v1/paybox/${appDetails.id}/operator-login`, { authorizationCode: authorizationCode });
    return response.data;
  } catch (e) {
    console.error(JSON.stringify(e));
    throw e;
  }
});
